
document.addEventListener('DOMContentLoaded', async () => {
    const grid = document.querySelector('.news-list-view');

    if (grid) {
        const Isotope = await import('isotope-layout');

        const iso = new Isotope(grid, {
            layoutMode: 'masonry',
            itemSelector: '.article',
            masonry: {
                gutter: 12
            }
        });
    }
});
